import { Link } from 'react-router-dom';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen pt-16 bg-white" data-testid="privacy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 
          className="text-4xl font-black text-slate-900 mb-8"
          style={{ fontFamily: 'Chivo, sans-serif' }}
        >
          Privacy Policy
        </h1>
        
        <p className="text-slate-600 mb-8">
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>

        <div className="prose prose-slate max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              1. Information We Collect
            </h2>
            <p className="text-slate-600 mb-4">
              MLC TECH ("we," "us," or "our") collects information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>Contact information (name, email address, phone number)</li>
              <li>Business information (company name, size, industry)</li>
              <li>Technical information related to IT support requests</li>
              <li>Communications and correspondence with our team</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              2. How We Use Your Information
            </h2>
            <p className="text-slate-600 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>Provide and improve our IT services</li>
              <li>Respond to your requests and inquiries</li>
              <li>Send you service-related communications</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              3. Information Sharing
            </h2>
            <p className="text-slate-600">
              We do not sell, rent, or share your personal information with third parties for their 
              marketing purposes. We may share information with service providers who assist us in 
              operating our business, subject to confidentiality agreements.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              4. Data Security
            </h2>
            <p className="text-slate-600">
              We implement industry-standard security measures to protect your information, including 
              encryption, access controls, and regular security assessments. However, no method of 
              transmission over the Internet is 100% secure.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              5. Your Rights
            </h2>
            <p className="text-slate-600 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              6. Contact Us
            </h2>
            <p className="text-slate-600">
              If you have questions about this Privacy Policy, please contact us at:{' '}
              <a href="mailto:info@mlctech.org" className="text-blue-600 hover:text-blue-700">
                info@mlctech.org
              </a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <Link to="/" className="text-blue-600 hover:text-blue-700 font-medium">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
